import { type DeliveriesState } from "./state";

export const initialState: DeliveriesState = {
  rows: [],
  listRequestId: null,
  loadMoreRequestId: null,
  summary: null,
  nextToken: undefined,
  isPending: false,
  isRejected: false,
  ambassadors: [],
  addresses: [],
  isMutating: false,
};
